module.exports = __webpack_public_path__ + "close.46a610b06894d550646a08f1e08f5861.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/close.svg
// module id = 382
// module chunks = 0